import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NatConfigurationList from './containers/NatConfigurationList';
import NatConfigurationCreate from './containers/NatConfigurationCreate';
import NatConfigurationView from './containers/NatConfigurationView';
import { SYSTEM_CONFIGURATION_ROUTE, NETWORK, NAT_CONFIGURATION_ROUTE } from '../../constants';
import NatConfigurationEdit from './containers/NatConfigurationEdit';

interface Props {
}

const NatConfiguration: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NAT_CONFIGURATION_ROUTE}`}>
        <NatConfigurationList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NAT_CONFIGURATION_ROUTE}/create`}>
        <NatConfigurationCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NAT_CONFIGURATION_ROUTE}/view`}>
        <NatConfigurationView />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${NAT_CONFIGURATION_ROUTE}/edit`}>
        <NatConfigurationEdit />
      </Route>
    </Fragment>
  );
};

export default NatConfiguration;
